import classNames from 'classnames'
import React from 'react'
import style from '../styles/buttons.module.scss'

interface IProps {
  children: any
  checked?: boolean
  onClick: () => void
}

const AgeButton = ({
  children,
  checked = false,
  onClick
}: IProps): React.ReactElement => {
  return (
    <button
      type='button'
      onClick={onClick}
      className={classNames({
        [style.agebtn]: true,
        [style['agebtn--checked']]: checked
      })}
    >
      {children}
    </button>
  )
}

export default AgeButton
